import React from "react";
import { FaAws, FaNodeJs, FaReact, FaJenkins } from "react-icons/fa";
import ServiceItem from "./ServiceItem";
import { TbBrandFlutter } from "react-icons/tb";
import { SiOpencv } from "react-icons/si";

const serviceData = [
  {
    id: 1,
    icon: <TbBrandFlutter />,
    title: "Mobile App Development",
    description:
      "Building high-performance, cross-platform mobile applications using Flutter.",
  },
  {
    id: 2,
    icon: <FaNodeJs />,
    title: "Api Development",
    description:
      "Designing robust and scalable RESTful APIs with Node.js for seamless backend integration.",
  },
  {
    id: 3,
    icon: <FaReact />,
    title: "Frontend Development",
    description:
      "Crafting responsive and intuitive user interfaces with React and modern frameworks.",
  },
  {
    id: 4,
    icon: <FaAws />,
    title: "AWS",
    description:
      "Implementing scalable cloud solutions with AWS services like Amplify, S3, and EC2.",
  },
  {
    id: 4,
    icon: <FaJenkins />,
    title: "CI/CD",
    description:
      "Automating deployment pipelines for efficient and reliable software delivery using Jenkins and GitHub Actions.",
  },
  {
    id: 4,
    icon: <SiOpencv />,
    title: "AI",
    description:
      "Developing intelligent applications powered by AI technologies like OpenCV and Google ML Kit.",
  },
];

const Service = () => {
  return (
    <section className="pb-10">
      <div className="flex flex-wrap md:px-4">
        {serviceData.map((service, id) => (
          <ServiceItem service={service} key={id} />
        ))}
      </div>
    </section>
  );
};

export default Service;
